document.addEventListener('alpine:init', () => {
    Alpine.data('postMetaBar', () => ({
        showAllTags: false,
        copyURLToClipboard: () => {
            navigator.clipboard.writeText(window.location.href);
        }
    }));
});